export const glassLensModel = {
    practitioner: '',
    manufacturer: '',
    model: '',
    odSphere: '',
    odCylinder: '',
    odAxis: '',
    odNearAdd: '',
    odDpd: '',
    odNpd: '',
    odHPrism: '',
    odHPrismExtra: '',
    odVPrism: '',
    odVPrismExtra: '',
    osSphere: '',
    osCylinder: '',
    osAxis: '',
    osNearAdd: '',
    osDpd: '',
    osNpd: '',
    osHPrism: '',
    osHPrismExtra: '',
    osVPrism: '',
    osVPrismExtra: '',
    comment: '',
};